<template>
  <v-row justify="center">
    <v-dialog :value="hasReference" persistent max-width="980">
      <v-card>
        <reference-form
          v-if="editedReference"
          v-model="editedReference"
          :focus-field="focusField"
          @save="onSave"
          @cancel="$emit('cancel')"
        />
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import ReferenceForm from './ReferenceForm';
import { Reference } from '@/models';

export default {
  name: 'ReferenceFormModal',
  components: { ReferenceForm },
  props: {
    reference: {
      type: Reference,
      default: () => null,
    },
    focusField: {
      type: String,
      default: null,
    },
  },
  emits: ['save', 'cancel'],
  data: () => ({ editedReference: null }),
  computed: {
    hasReference() {
      return !!this.reference;
    },
  },
  watch: {
    reference: function (newReference) {
      this.onNewReference(newReference);
    },
  },
  mounted() {
    this.onNewReference(this.reference);
  },
  methods: {
    onNewReference(reference) {
      if (reference) {
        this.editedReference = new Reference(reference);
        if (this.editedReference.publication.authors.length === 0) {
          this.$set(this.editedReference.publication, 'authors', [
            '',
          ]);
        }
        if (this.editedReference.publication.year === 0) {
          this.$set(this.editedReference.publication, 'year', '');
        }
      }
    },
    onSave() {
      // Ensure Author entries are valid, remove any empty.
      const authors = this.editedReference.publication.authors;
      this.editedReference.publication.authors = authors.filter(
        (author) => author && author.trim().length > 0
      );
      // If the year field is empty, then make year zero.
      const year = this.editedReference.publication.year;
      this.editedReference.publication.year = year === '' ? 0 : year;
      this.$emit('save', this.editedReference);
    },
  },
};
</script>
